<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_19966_289370"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path
        d="M11.1787 5.28588L14.7142 8.82141M2.33984 17.6602L6.11163 17.1778C6.29464 17.1544 6.4647 17.0709 6.59516 16.9404L17.0712 6.46436C17.7221 5.81349 17.7221 4.75821 17.0712 4.10734L15.8927 2.92883C15.2418 2.27796 14.1866 2.27796 13.5357 2.92883L3.05963 13.4049C2.92917 13.5354 2.84569 13.7054 2.82228 13.8884L2.33984 17.6602Z"
        stroke="black"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_19966_289370)">
      <rect width="20" height="20" fill="#091620" fill-opacity="0.8" />
    </g>
  </svg>
</template>
